<template>
	<div class="pt-10 h-screen" id="search">
		<div class="w-full flex flex-wrap container mx-auto">
			<SearchResult
				link="/artist"
				title="Le nom de mon resultat"
				image="https://sutter-nicolas.com/medias/moi.jpg"
			/>
			<SearchResult
				link="/artist"
				title="Le nom de mon resultat"
				image="https://sutter-nicolas.com/medias/moi.jpg"
			/>
			<SearchResult
				link="/artist"
				title="Le nom de mon resultat"
				image="https://sutter-nicolas.com/medias/moi.jpg"
			/>
		</div>
	</div>
</template>

<script>
import SearchResult from './searchResult.vue';

export default {
	name: 'Artists',
	components: {
		SearchResult
	}
};
</script>
